import { ReactElement } from 'react';

import { Patient } from '@dreryk/egabinet-patient-frontend-api';

import { AddCircleIcon, Table } from '@dreryk/react-components';

import { ConsentsAndAuthorizationsDocumentsModalOpener } from '../ConsentsAndAuthorizationsDocumentModal/ConsentsAndAuthorizationsDocumentsModal.opener';

import { AddConsentOrAuthorizationLink } from './AddConsentOrAuthorizationLink';
import {
   useConsentsAndAuthorizationsDataConfiguration,
   useConsentsAndAuthorizationsTableColumns,
} from './ConsentsAndAuthorizationsTable.hooks';
import { ConsentsAndAuthorizationsTableDataAccessor } from './ConsentsAndAuthorizationsTableDataAccessor';
import { ConsentsAndAuthorizationsTableEmptyStatePlaceholder } from './placeholder/ConsentsAndAuthorizationsTableEmptyStatePlaceholder';

type ConsentsAndAuthorizationsTableProps = {
   readonly patientId: Patient['id'];
};

export const ConsentsAndAuthorizationsTable = (props: ConsentsAndAuthorizationsTableProps): ReactElement => {
   const dataConfiguration = useConsentsAndAuthorizationsDataConfiguration({ patientId: props.patientId });
   const columns = useConsentsAndAuthorizationsTableColumns({
      refetchData: dataConfiguration.refetch,
      patientId: props.patientId,
   });

   return (
      <Table
         columns={columns}
         dataConfiguration={dataConfiguration}
         keyExtractor={'id'}
         placeholder={<ConsentsAndAuthorizationsTableEmptyStatePlaceholder patientId={props.patientId} />}
         testId={'consentsAndAuthorizationsTable'}
         dataAccessor={ConsentsAndAuthorizationsTableDataAccessor}
         bottomElement={
            <ConsentsAndAuthorizationsDocumentsModalOpener patientId={props.patientId}>
               {({ openModal }) => <AddConsentOrAuthorizationLink icon={<AddCircleIcon />} onClick={openModal} />}
            </ConsentsAndAuthorizationsDocumentsModalOpener>
         }
      />
   );
};
